export default "__VITE_ASSET__2becb5b3__"